<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectMaterials">
            <van-nav-bar
                title="选择原材料"
                left-text="价格变更"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <van-search v-model="Keywords" placeholder="请输入搜索信息" @change="search"></van-search>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item, i) in listData">
                                <li :key="i" @click="confirmSelection(item)">
                                    <div class="engineeringInfo">
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>原材料名称：{{ item.type_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>原材料子类：{{ item.child_type_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>原材料规格：{{ item.spec_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>货源地：{{ item.source_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>供应场站：{{ item.station_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>含税单价：{{ item.unit_price }}元</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>税率：{{ item.tax_rate }}%</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 选择原材料
    name: 'select-materials',
    components: {},
    props: {},
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 当前页码
            pageIndex: 0,
            // 列表数据
            listData: [],
            // 查询条件
            Keywords: '',
            // 合同id
            ciid: '',
            // 原材料下标
            index: 0,
        };
    },
    computed: {},
    watch: {},
    created() {
        // 合同id
        this.ciid = this.$route.params.ciid;
        // 原材料下标
        this.index = this.$route.params.index;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.pageIndex = 1;
            this.listData = [];
            this.finished = false;
            this. isLoading = true;
            this.isUpLoading = false;
            this.getListData();
        },
        // 上拉加载更多
        onLoad() {
            this. isLoading = false;
            this.isUpLoading = true;
            this.pageIndex++;
            this.getListData();
        },
        // 获取列表数据
        getListData() {
            this.$axios
                .get('/interfaceApi/Procurement/material/price/adjust/getcontractmaterialpage?'
                    + `ciid=${this.ciid}&pageindex=${this.pageIndex}&pagesize=4&searchkey=${this.Keywords}`)
                .then(res => {
                    if (res.rows.length > 0) {
                        this.listData.push(...res.rows);
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }
                    this. isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this. isLoading = false;
                    this.isUpLoading = false;
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        // 搜索
        search() {
            this.pageIndex = 1;
            this.listData = [];
            this.finished = false;
            this. isLoading = true;
            this.isUpLoading = false;
            this.getListData();
        },
        // 确认选择原材料
        confirmSelection(item) {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'newPriceAdjustment',
                params: {
                    rawMaterial: item,
                    index: this.index,
                },
            });
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.selectMaterials
    height 100%
    section
        height calc(100% - 85rpx)
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                height 100%
                overflow-y auto
                background #F0F0F0
                padding 0 15rpx
                padding-bottom 0
                li
                    width 100%
                    background #fff
                    overflow hidden
                    margin-bottom 15rpx
                    position relative
                    &:first-child
                        margin-top 15rpx
                    .engineeringInfo
                        position relative
                        padding 15rpx
                        padding-bottom 0
                        img,span
                            float left
                            height 16rpx
                            line-height 16rpx
                        img
                            width 16rpx
                            margin-right 12rpx
                        h4,p
                            overflow hidden
                        h4
                            margin-bottom 14rpx
                            width 100%
                            span
                                display inline-block
                                width 100%
                                font-size 18rpx
                                height 20rpx
                                line-height 20rpx
                                color #061F3E
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                &:before
                                    font-size 20rpx
                                    margin-right 10rpx
                                    color #5588F1
                        p
                            margin-bottom 14rpx
                            span
                                display inline-block
                                width calc(100% - 40rpx)
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                font-size 14rpx
                                color #666666
</style>